export default "__VITE_ASSET__BEQ_bsXN__"